var bsLib = {
  /**
   * A native JS extend() function.
   * https://gist.github.com/cferdinandi/4f8a0e17921c5b46e6c4
   * Merge defaults with user options
   * @private
   * @param {Object} defaults Default settings
   * @param {Object} options User options
   * @returns {Object} Merged values of defaults and options
   */
  extend: function (defaults, options, options2) {
    var extended = {};
    var prop;
    for (prop in defaults) {
      if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
        extended[prop] = defaults[prop];
      }
    }
    for (prop in options) {
      if (Object.prototype.hasOwnProperty.call(options, prop)) {
        extended[prop] = options[prop];
      }
    }
    if (options2) {
      for (prop in options2) {
        if (Object.prototype.hasOwnProperty.call(options2, prop)) {
          extended[prop] = options2[prop];
        }
      }
    }
    return extended;
  },

  validURL: function (url) {
    var pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + //port
      "(\\?[;&amp;a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    );
    return pattern.test(url);
  },

  validEmail: function (email) {
    return email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,15})+$/);
  },

  validPhoneNo: function(phoneno) {
    return phoneno.match(/^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g);
  },

  emailContainsNonLatinCharacters: function (email) {
    var emailSplits = email.split('@');
    if (emailSplits.length > 2) {
      return true;
    }
    return !/^[a-zA-Z0-9.'+-_|~]*$/.test(emailSplits[0]) || !/^[a-zA-Z0-9.-]*$/.test(emailSplits[1]);
  },

  /**
   * http://youmightnotneedjquery.com/
   * Ajax method in JavaScript xhr request
   */
  ajax: function (type, url, data, async, requestHeader, success, error, sendDataFormat, withCredentials) {
    /**
     * https://www.tutorialspoint.com/How-to-validate-URL-address-in-JavaScript
     * Check if URL is valid.
     */

    if (!this.validURL(url)) {
      return false;
    }

    var request;
    if (window.XMLHttpRequest) {
      // code for Modern browsers
      request = new XMLHttpRequest();
    } else {
      // code for older browsers
      request = new ActiveXObject("Microsoft.XMLHTTP");
    }
    var edsURL = 'https://' + EdsConfig.server + ':' + EdsConfig.port + '/send_event';
    if (edsURL === url) {
      bsLib.EDSAsync = async;
    }
    request.open(type, url, async);

    if (requestHeader) {
      Object.keys(requestHeader).forEach(function eachKey(key) {
        request.setRequestHeader(key, requestHeader[key]);
      });
    }

    // handle readystatechange event
    request.onreadystatechange = function () {
      // check readyState property
      // 4 signifies DONE
      // Not checking status below 200 because there is no action item for those error.
      if (this.readyState === 4 || this.status >= 200) {
        // req.status of 200 means success
        if (this.status === 200) {
          /**
           * This will exceute the custom message or task on success based on form API response.
           * In our case it will show the pop-up modal.
           */
          success(request);
        } else if (this.status >= 200) { // Not checking status below 200 because there is no action item for those error.
          // handle request failure
          error(request); // To add any custom error based on requirement
          if (!window.location.hostname.match("wpengine") && !window.location.hostname.match("bsstag")) {
            if (type == "GET") {
              var form_err = "User Token failed with Error " + this.status + ": " + this.statusText;
              if (this.status === 401 
                && Cookie.read(stage_env_cookie_prefix + 'bs_logging_id')
                && this.responseURL.indexOf("user/show-tos-pp-notification") !== -1
                && window.hasOwnProperty('tosConfirmationOptions') 
                && tosConfirmationOptions.enable
              ) {
                  //delete cookie signed in and redirect
                  Cookie.erase(stage_env_cookie_prefix + 'bs_logging_id');

                  window.location.href = tosConfirmationOptions.redirect_url;
              } else if (this.status === 401 
                && Cookie.read(stage_env_cookie_prefix + 'bs_logging_id')
                && (this.responseURL.indexOf("/user/user-info") !== -1
                || this.responseURL.indexOf("/api/v1/user?product=wp") !== -1)
                ) {
                // add this check for /user/userinfo endpoint for hellobar API exp
                if (this.readyState === 4) {
                  //delete cookie signed in and reload
                  Cookie.erase(stage_env_cookie_prefix + 'bs_logging_id');

                  //Show alert
                  new bsAlert({
                    alertType: "error",
                    timeout: 4000,
                    htmlMessage: true,
                    text: Messages.salesAndSupportPage.somethingWrong
                  });
                  
                  console.error(form_err);
                }
              } else if ((this.status >= 200 && this.status <= 401)
                && (this.responseURL.indexOf("/trust/nda") !== -1
                || this.responseURL.indexOf("/trust/certificate_download") !== -1)) { // trust center API
                if (this.readyState === 4) {
                  console.log("Log " + this.status + ": " + this.statusText);
                }
              } else {
                // Standard error for all the form failed case
                console.error(form_err);
                Sentry.captureException(form_err);
              }
            } else {
              //CloudFlare 429 Error Code notification display
              if (this.status === 429) {
                new bsAlert({
                  alertType: "error",
                  timeout: false,
                  htmlMessage: true,
                  text: Messages.cloudflareErrorStatusCode[429]
                });
              } else if (this.status === 401 && this.responseURL.indexOf("/users/google-one-tap") !== -1 ) {
                // add this check for /users/google-one-tap endpoint for hellobar API exp
                if (this.readyState === 4) {
                  var dataRequest = bsLib.JSONParse(this.responseText);
                  
                  if (typeof dataRequest.error !== 'undefined') {
                    new bsAlert({
                      alertType: "error",
                      timeout: false,
                      htmlMessage: true,
                      text: dataRequest.error
                    });
                  }
                }
              }

              // Standard error for all the form failed case
              var form_err = "XHR request failed with Error " + this.status + ": " + this.statusText;
              console.error(form_err);
              Sentry.captureException(form_err);
            }
          }
        }
      }
    };

    request.onerror = function () {
      // There was a connection error of some sort
      // Not checking status below 200 because there is no action item for those error.
      if(request.status >= 200) {
        var form_err =
          "XHR not able to make connection with Error " + request.status + ": " + request.statusText;
        console.error(form_err);
        Sentry.captureException(form_err);
      }
    };

    /** Do not remove this code might be useful in future. */

    /**
     * Returned values are always in strings and when we try to store that value it retruns [object Object]
     * Hence tried to convert the returing value in desired json format without braceses and quotes.
     * Ref : https://stackoverflow.com/questions/44792322/store-json-without-brackets-and-quotes
     */

    // var result = Object.entries(data).reduce(function (result, _ref) {
    //   var key = _ref[0],
    //       value = _ref[1];
    //   key = key.replace(/([A-Z]|\d+)/g, ' $1').replace(/^(.)/, function (unused, p1) {
    //     return p1.toLowerCase();
    //   });

    //   if (!['string', 'number', 'boolean'].includes(typeof(value))) {
    //     value = Object.entries(value).map(function (_ref2) {
    //       var key = _ref2[0],
    //           value = _ref2[1];
    //       return typeof value == 'boolean' ? value ? key : undefined : value;
    //     }).filter(function (v) {
    //       return v !== undefined;
    //     }).join(',');
    //   }

    //   result.push(key + ": " + value);
    //   return result;
    // }, []);

    /**
     * Convert form data in urlencoded format
    */

    if (withCredentials) {
      request.withCredentials = true;
    }

    //set utm tracking    
    //check api url only path
    //ref: https://stackoverflow.com/questions/736513/how-do-i-parse-a-url-into-hostname-and-path-in-javascript
    var parserLinkNode = document.createElement('a');
    parserLinkNode.href = url;

    if (typeof parserLinkNode.pathname !== 'undefined') {
      checkURL = parserLinkNode.pathname;
      
      if (checkURL.indexOf("contact") !== -1 
        || checkURL.indexOf("users") !== -1 
        || checkURL.indexOf("capture-lead") !== -1 
        || checkURL.indexOf("user/initate_demo_chat") !== -1
        || checkURL.indexOf("wp-admin/admin-ajax.php") !== -1
      ) {

        var whiteListParams = [
          'utm_source',
          'utm_medium',
          'utm_platform',
          'utm_content',
          'utm_campaign',
          'utm_campaigncode',
          'utm_term'
        ], paramsObj = window.location.search
        .slice(1)
        .split('&')
        .map(function (p) {
          return p.split('=');
        })
        .reduce(function (obj, pair) {
          if (pair.length >= 2) {
            obj[pair[0]] = pair[1];
          }
          return obj;
        }, {});

        var pageSlug = window.location.pathname;
        pageSlug = pageSlug.replace(/^\/|\/$/g, '');
        pageSlug = pageSlug.split('/')[0];

        //Read from cookie
        if (Object.keys(paramsObj).length == 0) {
          var cookieUtmParams = Cookie.read(stage_env_cookie_prefix + "user_utm_data");
          if (cookieUtmParams) {
            paramsObj = bsLib.JSONParse(cookieUtmParams);
          }
        }

        //for signin users endpoint convert it to object
        if (checkURL.indexOf("users/google-one-tap") === -1 && checkURL.indexOf("users") !== -1) {
          data = bsLib.JSONParse(data);
        }

        // check white list params
        Object.keys(paramsObj).forEach(function (key) {
          if (whiteListParams.indexOf(key) > -1) {
            // condition to check sfdc campaign code id field for DG pages
            if (!(checkURL.indexOf("contact") !== -1
              && pageSlug === 'dg'
              && data.hasOwnProperty("utm_campaigncode")
              && key === 'utm_campaigncode')) {
              data[key] = paramsObj[key];
            }
          }
        });

        //stringify signin users endpoint data
        if (checkURL.indexOf("users/google-one-tap") === -1 && checkURL.indexOf("users") !== -1) {
          data = JSON.stringify(data);
        }
      }
    }
   
    if (!sendDataFormat) {
      // When api response required content type : "application/x-www-form-urlencoded; charset=UTF-8"
      var transformRequest = function (d) {
        var str = [];
        for (var p in d) {
          if (d[p]) { // check for null values
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(d[p]));
          }
        }
        return str.join("&");
      };
    
      request.send(transformRequest(data));
    } else {
      // When api response required content type : application/json
      request.send(data);
    }
    
  },

  /**
   * Get IE version Number
   * https://stackoverflow.com/questions/19999388/check-if-user-is-using-ie
   */

  msieversion: function () {
    var ua = window.navigator.userAgent,
    msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      // If Internet Explorer, return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
    } // If another browser, return 0
    return false;
  },

  /*
   * Scroll to element position
   * https://gist.github.com/ravid7000/f54a37fd131a0b2e5ed190b6f58a1bc9
   * scrollTo(element.scrollTop || 200, 400)
   */
  scrollIt: function (to, duration) {
    var element = document.scrollingElement,
    start = (element && element.scrollTop) || window.pageYOffset,
    change = to - start,
    increment = 20,
    currentTime = 0;

    function easeInOutQuad(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    }

    //animation scroll
    var animateScroll = function() {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      window.scrollTo(0, val);
      if (currentTime < duration) {
        window.setTimeout(animateScroll, increment);
      }
    };

    animateScroll();
  },

  uniqueID: function () {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 12 characters
    // after the decimal.
    return Math.random().toString(36).substr(2, 12);
  },
  getParameterByName: function(name, url) {
    /*
    * Get Query Params from JS because WPEngine remove utm_* and gclid from GET object.
    * Ref : https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
    */
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },
  /**
   * Check Valid JSON and return object if json valid
   * @param {string} str
   * @returns boolean 
   */
  JSONParse: function(str) {
    try {
      var o = JSON.parse(str);

      if (o && typeof o === "object") {
          return o;
      }
    }
    catch (e) { }

    return false;
  },
  railsHost: function () {
    // return railshost url for API call
    return window.location.protocol + "//" + window.location.hostname;
  },

  GAClientID: function() {
    var ga_client_id = Cookie.read("_ga");

    if (ga_client_id) {
      ga_client_id = ga_client_id.split(".");
      if (ga_client_id.length >= 4) {
        return ga_client_id[2] + '.' + ga_client_id[3];
      }
    }
    
    //if gaClientId is not return empty string
    return '';
  },

  getTimeZone: function() {
    var offset = new Date().getTimezoneOffset(), o = Math.abs(offset);
    return (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
  },

  getTimeZoneLocation: function() {
    return Intl.DateTimeFormat('en-US').resolvedOptions().timeZone;
  }
};
